<ng-progress id="progressBar" [spinner]="false"></ng-progress>
<div class="header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <img src="/assets/images/logo-white.png">
            </div>
            <div class="col-md-6 d-flex align-items-center jus-cont-custom">
                <button type="button" class="btn btn-outline-default text-white d-block d-sm-none" (click)="onClickShowSidebar()">
                    <i class="fa-solid fa-bars"></i>
                </button>
                <div ngbDropdown class="d-inline-block">
                    <span class="text-white">{{ dataUser?.sub }}</span>
                    <button type="button" class="btn btn-outline-default text-white" id="dropdownBasic1" ngbDropdownToggle>
                        <i class="fa-solid fa-gear"></i>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                        <button ngbDropdownItem (click)="onClickChangePassword()">Cambiar contraseña</button>
                        <button ngbDropdownItem (click)="onClickLogout()">Salir</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="sidebar" [ngClass]="{'show-mobile': showSidebar}">
 <ul>
    <li>
        <a [routerLink]="[ '/admin/parametros' ]" (click)="onClickShowSidebar()">Parametros</a>
    </li>
    <li>
        <a [routerLink]="[ '/admin/usuarios' ]" (click)="onClickShowSidebar()">Usuarios</a>
    </li>
    <li>
        <a [routerLink]="[ '/admin/secciones' ]" (click)="onClickShowSidebar()">Secciones</a>
    </li>
    <li>
        <a [routerLink]="[ '/admin/categorias' ]" (click)="onClickShowSidebar()">Categorias</a>
    </li>
    <li>
        <a [routerLink]="[ '/admin/productos' ]" (click)="onClickShowSidebar()">Productos</a>
    </li>
    <li>
        <a [routerLink]="[ '/admin/segmentos' ]" (click)="onClickShowSidebar()">Segmentos</a>
    </li>
    <li>
        <a [routerLink]="[ '/admin/claves' ]" (click)="onClickShowSidebar()">Claves</a>
    </li>
    <li>
        <a [routerLink]="[ '/admin/tablas' ]" (click)="onClickShowSidebar()">Tablas</a>
    </li>
    <li>
        <a [routerLink]="[ '/admin/formularios' ]" (click)="onClickShowSidebar()">Formularios</a>
    </li>
    <li>
        <a [routerLink]="[ '/admin/logs' ]" (click)="onClickShowSidebar()">Logs</a>
    </li>
    <li>
        <a [routerLink]="[ '/login' ]" (click)="onClickLogout()">Salir</a>
    </li>
 </ul>
</div>
<div class="wrapper">
    <router-outlet></router-outlet>
</div>

<ng-template #passwordModal let-modalPassword>
    <div class="modal-header">
        <h4 class="card-title">Cambiar contraseña</h4>
        <button class="btn-close" (click)="modalPassword.close(); VerificateChangePassword()"></button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label for="">Contraseña actual</label>
            <input type="password" class="form-control" [(ngModel)]="formPassword.password">
        </div>
        <div class="form-group">
            <label for="">Nueva contraseña</label>
            <div class="input-group">
                <input [type]="typeInput" class="form-control" [(ngModel)]="formPassword.newPassword" (input)="validateNewPassword()">
                <span class="input-group-text hand" (click)="showPassword()">
                    <i class="fa-solid fa-eye"></i>
                </span>
            </div>
        </div>
        <div class="form-group">
            <label for="">Repetir contraseña</label>
            <input [type]="typeInput" class="form-control" [(ngModel)]="formPassword.newPasswordConfirm" (input)="validateNewPassword()">
        </div>
        <span [ngClass]="{'text-danger': !characterMore, 'text-success': characterMore }"><i>Contraseña debe ser mínimo 6 caracteres</i></span>
        <br>
        <span [ngClass]="{'text-danger': !characterSpecial, 'text-success': characterSpecial }"><i>Contraseña debe tener al menos un caracter especial</i></span>
        <br>
        <span [ngClass]="{'text-danger': !passwordSame, 'text-success': passwordSame }"><i>Los campos de contraseña nueva no coinciden</i></span>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="onClickUpdate()">
            Actualizar
        </button>
    </div>
</ng-template>
